import { render, staticRenderFns } from "./addScheduleClassesStaff.vue?vue&type=template&id=67fcce8f&scoped=true"
import script from "./addScheduleClassesStaff.vue?vue&type=script&lang=js"
export * from "./addScheduleClassesStaff.vue?vue&type=script&lang=js"
import style0 from "./addScheduleClassesStaff.vue?vue&type=style&index=0&id=67fcce8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fcce8f",
  null
  
)

export default component.exports